import { createActionGroup, emptyProps, props } from '@ngrx/store';
import {
  ManagedUser,
  ManagedUserSaveResult,
} from '../models/managed-user.model';
import { UserFormModel } from '../models/user-form.model';
import { MultiBuyerEntity } from '../models/multi-buyer-entity.model';
import { ProjectManager } from '../models/project-manager.model';
import {
  UserCompanyDetail,
  UserCompanySummary,
} from '../models/user-company.model';

export const UserActions = createActionGroup({
  source: 'Manage Users',
  events: {
    'Load Users': props<{ page: number }>(),
    'Load Users Success': props<{ users: ManagedUser[]; count: number }>(),
    'Load Users Failure': props<{ error: string }>(),

    'Change Search': props<{ search: string }>(),

    'Select User': props<{ userId: number }>(),
    'Start Create': emptyProps(),
    'Clear Form': emptyProps(),
    'Reset State': emptyProps(),

    'Load Companies': emptyProps(),
    'Load Companies Success': props<{ companies: UserCompanySummary[] }>(),
    'Load Companies Failure': props<{ error: string }>(),

    'Load Company Detail': props<{ companyId: number }>(),
    'Load Company Detail Success': props<{
      companyDetail: UserCompanyDetail;
    }>(),
    'Load Company Detail Failure': props<{ error: string }>(),

    'Load Multi Buyer Entities': props<{ companyId: number }>(),
    'Load Multi Buyer Entities Success': props<{
      entities: MultiBuyerEntity[];
    }>(),
    'Load Multi Buyer Entities Failure': props<{ error: string }>(),

    'Load Project Managers': props<{ companyId: number }>(),
    'Load Project Managers Success': props<{
      projectManagers: ProjectManager[];
    }>(),
    'Load Project Managers Failure': props<{ error: string }>(),

    'Save User': props<{ form: UserFormModel }>(),
    'Save User Success': props<{ result: ManagedUserSaveResult }>(),
    'Save User Failure': props<{ error: string }>(),

    'Toggle User Status': props<{ user: ManagedUser }>(),
    'Toggle User Status Success': props<{ message: string }>(),
    'Toggle User Status Failure': props<{ error: string }>(),

    'Load Api Token': props<{ userId: number }>(),
    'Load Api Token Success': props<{ token: string }>(),
    'Load Api Token Failure': props<{ error: string }>(),
    'Clear Api Token': emptyProps(),
  },
});
